export default __webpack_public_path__ + "static/media/sunrise_beaugrenelle.9c21098f.jpg";